import {PassedInitialConfig} from 'angular-auth-oidc-client';
import {environment} from '../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    secureRoutes: [
      environment.baseUrl,
      `${environment.baseUrl}/api`,
      '/api',
      '/secure/'
    ],
    authority: `${environment.oidcIssuerUrl}`,
    redirectUrl: window.location.origin + '/ui/callback',
    postLogoutRedirectUri: window.location.origin + '/ui/logout',
    clientId: environment.clientId,
    scope: 'openid profile email',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    autoUserInfo: true,
    renewUserInfoAfterTokenRenew: true,
    ignoreNonceAfterRefresh: true,
    renewTimeBeforeTokenExpiresInSeconds: 60,
    startCheckSession: true,
    triggerRefreshWhenIdTokenExpired: true,
    logLevel: environment.ngOidcLogLevel,
    maxIdTokenIatOffsetAllowedInSeconds: 900, //15mn
    unauthorizedRoute: '/error/401',
    forbiddenRoute: '/error/403',
  }
}
